import CommonConfig from "../config/common";
import { PUBLIC_LOCATION } from "../commander/Types";
import { assignRecursive } from "./main";

// "common" is for the texts that are the same for all games,
// and "game" is for the ones specific for the given game
type TextsType = "game" | "common";
const LANGUAGES = {} as any;
const tryLoadLang = async (
  type: TextsType,
  code: string,
  fallback: any = {}
) => {
  try {
    if (type === "common") {
      const main = await import(`../languages/common/${code}`);
      return main;
    } else {
      const response = await fetch(
        `${PUBLIC_LOCATION}/game/languages/${code}.json`
      );
      const data = response.ok ? await response.json() : fallback;

      return data;
    }
  } catch (e) {
    return fallback;
  }
};

const _loadTexts = async (type: TextsType, code: string): Promise<any> => {
  // the "social casino" language code is "en_sc" hence the check
  const separator = code.includes("_") ? "_" : "-";
  // for "pt-br" the parentCode will be "pt", for "jp" the parentCode will be "jp"
  const [parentCode] = code.toLowerCase().split(separator);
  const main = await tryLoadLang(type, code, null);
  const parent =
    parentCode !== code ? await tryLoadLang(type, parentCode, null) : {};

  const fallback = code === "en" ? {} : await tryLoadLang(type, "en");

  if (parent === null && main === null && code !== "en") {
    return loadTexts(type, "en");
  }

  return Object.assign({}, fallback, parent, main);
};

export const loadTexts = async (
  type: TextsType,
  code: string
): Promise<any> => {
  if (LANGUAGES[code] && LANGUAGES[code][type]) return LANGUAGES[code][type];

  LANGUAGES[code] = LANGUAGES[code] ?? {};
  LANGUAGES[code][type] = _loadTexts(type, code);

  return LANGUAGES[code][type];
};

export const getModuleFromScript = async (src: string) => {
  try {
    const response = await fetch(src);
    const scriptContent = await response.text();
    const blob = new Blob([scriptContent], { type: "application/javascript" });
    const moduleUrl = URL.createObjectURL(blob);
    const _import = await import(/* webpackIgnore: true */ moduleUrl);

    return _import.default;
  } catch (e) {
    return {};
  }
};

let CONFIG: any = null;
const _loadConfig = async () => {
  try {
    const cfg = await getModuleFromScript(`${PUBLIC_LOCATION}/game/config.js`);
    return assignRecursive(CommonConfig, cfg);
  } catch {
    return CommonConfig;
  }
};

export const getConfig = async () => {
  if (CONFIG) return CONFIG;
  CONFIG = _loadConfig();

  return CONFIG;
};
